import { API } from "aws-amplify";
import store from "@/store";
import uuidv4 from "uuid/v4";

export async function getConsultas() {
  //console.log("export async function getConsultas()")

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/ec/dashboard/consultas"; //replace this with the path you have configured on your API
  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: {
      ruc: store.getters.empresa.ruc
    }
  };
  let result = await API.get(apiName, path, myInit);
  console.log(result);
  return result.data;
}

export async function postConsulta(descripcion, owner) {
  //console.log("export async function postConsulta(name, filters) ")

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/ec/dashboard/consultas"; //replace this with the path you have configured on your API
  let myInit = {
    body: {
      uuid: uuidv4(),
      ruc: store.getters.empresa.ruc,
      descripcion: descripcion,
      filtros: store.getters.filters,
      uuidEmpresa: store.getters.empresa.uuidEmpresa,
      owner
    },
    headers: {} // OPTIONAL
  };
  let result = await API.post(apiName, path, myInit);
  return result;
}

export async function putConsulta(query) {
  console.log("API export async function putConsulta(query) {");

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/ec/dashboard/consultas"; //replace this with the path you have configured on your API
  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      query: query,
      ruc: store.getters.empresa.ruc
    } // replace this with attributes you need
  };

  await API.put(apiName, path, myInit)
    .then(response => {
      // Add your code here
      console.log(response);
      return response;
    })
    .catch(error => {
      console.log(error.response);
    });

  //let result = await API.delete(apiName, path, myInit);
  //console.log("resultado:",result);
}

export async function deleteConsultas(selected) {
  console.log("API export async function deleteConsultas(selected) {");

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/ec/dashboard/consultas"; //replace this with the path you have configured on your API
  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      selected: selected
    } // replace this with attributes you need
  };

  await API.del(apiName, path, myInit)
    .then(response => {
      // Add your code here
      console.log(response);
      return response;
    })
    .catch(error => {
      console.log(error.response);
    });

  //let result = await API.delete(apiName, path, myInit);
  //console.log("resultado:",result);
}
